import { OPERATION_TYPE, PAYMENT_TYPE } from "enums/payments";

export const DELIVERY_METHOD = {
    COURIER: "courier",
    PICKUP: "pickup",
    POST: "post",
}

export const ORDER_STATUS = {
    NEW: "NEW",
    PROCESSING: "PROCESSING",
    PAID: "PAID",
    ACCEPTED: "ACCEPTED",
    DELIVERY: "DELIVERY",
    DELIVERED: "DELIVERED",
    COMPLETED: "COMPLETED",
    CANCELLED: "CANCELLED",
    RETURNED: "RETURNED",
}

export const ORDER_SUB_STATUS = {
    FULLY_PAID: "FULLY_PAID",
    PARTIALLY_PAID: "PARTIALLY_PAID",
}

export const OFFER_STATUS = {
    IN_REVIEW: 'IN_REVIEW',
    AVAILABLE: 'AVAILABLE',
    NOT_AVAILABLE: 'NOT_AVAILABLE',
}


export const i18n = {
    [PAYMENT_TYPE.PREPAY]: "Предоплата",
    [PAYMENT_TYPE.FINAL]: "Окончательный платеж",
    [PAYMENT_TYPE.FULL]: "Полная оплата",
    [PAYMENT_TYPE.REFUND]: "Возврат денежных средств",
    [PAYMENT_TYPE.PENALTY]: "Штраф",
    [PAYMENT_TYPE.EXTRA]: "Дополнительная оплата",
    [PAYMENT_TYPE.INSTALLMENT]: "Ежемесячный платеж",

    [ORDER_STATUS.NEW]: "Новый",
    [ORDER_STATUS.PAID]: "Оплачен",
    [ORDER_STATUS.PROCESSING]: "В обработке",
    [ORDER_STATUS.DELIVERY]: "Отправлен",
    [ORDER_STATUS.DELIVERED]: "Доставлен",
    [ORDER_STATUS.COMPLETED]: "Завершен",
    [ORDER_STATUS.CANCELLED]: "Отменен",
    [ORDER_STATUS.RETURNED]: "Возврат",

    [DELIVERY_METHOD.COURIER]: "Курьер",
    [DELIVERY_METHOD.PICKUP]: "Самовывоз",
    [DELIVERY_METHOD.POST]: "Почта",

    [OPERATION_TYPE.PAYMENT]: "Платеж",
    [OPERATION_TYPE.REFUND]: "Возврат",

    [ORDER_SUB_STATUS.FULLY_PAID]: "Оплачен полностью",
    [ORDER_SUB_STATUS.PARTIALLY_PAID]: "Оплачен частично",

    [OFFER_STATUS.IN_REVIEW]: "На рассмотрении",
    [OFFER_STATUS.AVAILABLE]: "В продаже",
    [OFFER_STATUS.NOT_AVAILABLE]: "Снят с продажи",
}